import { StandardUserRoles } from '@quadminds/shared/commons';
import { IDriversToView, IVehiclesToView } from './update-organization-user.interface';
import { StandardStorkRoles, StorkModules } from '../enums';

export interface ISendInvitesDto {
    email: string[];
    permissions?: string[];
    modulesToView?: StorkModules[];
    vehiclesToView?: IVehiclesToView[];
    driversToView?: IDriversToView[];
    roles?: (StandardStorkRoles | StandardUserRoles)[];
}
